import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { ModalStatus } from "Types/modal";

interface IState {
  status: ModalStatus;
  data?: { [key: string]: any };
}

const initialState: IState = {
  status: "disable",
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    changeModal: (state, action: PayloadAction<IState>) => {
      return { status: action.payload.status, data: action.payload.data };
    },
    closeModal: (state) => {
      return { ...state, status: "disable" };
    },
  },
});

export const { changeModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
